/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Model'];
const factory = function (Model) {
  class AddOn extends Model {
    static initClass() {
      this.prototype.$resource = 'addon';
      this.prototype.id = null;
      this.prototype.clientId = null;
      this.prototype.name = '';
      this.prototype.details = null;
      this.prototype.accountType = 'MERCHANT_PROCESSOR';
      this.prototype.volume = 'LOW';
      this.prototype.closeDayOfMonth = 0;
      this.prototype.thirdPartyLoginAvailable = null;
      this.prototype.collectionMethod = null;
    }
    $postUrl() {
      return `${this.$resource}.json`;
    }

    // overrides to prevent usage
    $fetch() {}

    $fetchJECount() {
      return this.$apiCall({
        method: 'GET',
        url: `addon.json/${this.$storeId()}/je-count`,
      }).then(res => this.$set({ entryCount: res.data }));
    }
  }
  AddOn.initClass();

  AddOn.typeLabels = {
    MERCHANT_PROCESSOR: 'Merchant Processor',
    PAYROLL: 'Payroll Provider',
    LOAN_LOC_CAPITAL_LEASE: 'Loan / LOC / Lease',
    PERSONAL_BUSINESS_CROSSOVER: 'Personal-Business Crossover',
    PERSON_CONTRIBUTION: 'Personal Contribution',
    TAGGING_AND_REPORTING: '1099 Tagging & Reporting',
    CUSTOM_ADJUSTEMENTS: 'Custom Adjustments',
    RECEIPTS: 'Receipts',
    CHECKS: 'Checks',
    INTERCOMPANY_LOAN: 'Intercompany Loan',
    REIMBURSEMENTS: 'Reimbursements',
    CASH_RECONCILIATION: 'Cash Reconciliation',
    PRO: 'PRO',
    OTHER: 'Other',
    BENCH_TAX: 'BenchTax',
  };

  AddOn.typeAbbrs = {
    MERCHANT_PROCESSOR: 'Merchant Processor',
    PAYROLL: 'Payroll Provider',
    LOAN_LOC_CAPITAL_LEASE: 'Loan / LOC / Lease',
    PERSONAL_BUSINESS_CROSSOVER: 'Personal-Business Crossover',
    PERSON_CONTRIBUTION: 'Personal Contribution',
    TAGGING_AND_REPORTING: '1099 Tagging & Reporting',
    CUSTOM_ADJUSTEMENTS: 'Custom Adjustments',
    RECEIPTS: 'Receipts',
    CHECKS: 'Checks',
    ADDON: 'Add-on',
    LEDGER: 'Ledger',
    INTERCOMPANY_LOAN: 'Intercompany Loan',
    REIMBURSEMENTS: 'Reimbursements',
    CASH_RECONCILIATION: 'Cash Reconciliation',
    PRO: 'PRO',
    BENCH_TAX: 'Bench Tax',
    OTHER: 'Other',
  };

  return AddOn;
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular.module('bench.data.model.addOn', moduleDeps).factory('AddOn', factory);
